import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 border-b border-[#e3eaf4] px-7 py-3.5 bg-white z-10 flex items-center justify-between gap-4" }
const _hoisted_2 = { class: "text-[1.3rem] font-black tracking-tight text-[#173b5f]" }
const _hoisted_3 = { class: "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-7 py-5 space-y-5 modal-body-scroll" }
const _hoisted_4 = { class: "rounded-[1.4rem] border border-[#d3e2f2] bg-gradient-to-br from-[#f8fbff] via-[#ffffff] to-[#edf4fc] shadow-sm overflow-hidden" }
const _hoisted_5 = { class: "flex items-center justify-between px-6 py-2.5 bg-white/70 border-b border-[#e6eff8] text-[11px]" }
const _hoisted_6 = { class: "flex items-center gap-1.5 font-extrabold uppercase tracking-wider text-[10px] text-[#748197]" }
const _hoisted_7 = { class: "flex items-center gap-1.5 rounded-full border border-[#d8e4f0] bg-white px-2.5 py-0.5 shadow-2xs" }
const _hoisted_8 = { class: "p-6 md:p-7 grid gap-8 md:grid-cols-[1.12fr_0.88fr] items-start" }
const _hoisted_9 = { class: "space-y-3.5 min-w-0 pr-1" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "absolute -top-1.5 -right-1.5 flex items-center gap-1 z-10 opacity-80 group-hover:opacity-100 transition-opacity" }
const _hoisted_12 = { class: "h-8 w-8 rounded-full bg-[#eaf3fb] text-[#2855a6] flex items-center justify-center group-hover:scale-105 transition-transform shrink-0" }
const _hoisted_13 = {
  key: 2,
  class: "text-[11px] text-[#be243d] font-bold mt-1"
}
const _hoisted_14 = { class: "pt-1" }
const _hoisted_15 = {
  key: 0,
  class: "space-y-0.5"
}
const _hoisted_16 = { class: "text-[2rem] font-black text-[#062d5f] uppercase tracking-tight leading-[1.02] break-words" }
const _hoisted_17 = {
  key: 1,
  class: "space-y-1"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "text-xs text-[#be243d] font-bold mt-1"
}
const _hoisted_20 = { class: "space-y-0 border-t border-[#e2edf8]" }
const _hoisted_21 = { class: "flex items-start gap-3 py-3 border-b border-[#e9f1fa]" }
const _hoisted_22 = { class: "h-9 w-9 rounded-full bg-[#e5192d] text-white flex items-center justify-center shrink-0 shadow-2xs mt-0.5" }
const _hoisted_23 = { class: "min-w-0 flex-1 space-y-2" }
const _hoisted_24 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = ["min"]
const _hoisted_28 = { class: "flex items-center gap-3 py-3 border-b border-[#e9f1fa]" }
const _hoisted_29 = { class: "h-9 w-9 rounded-full bg-[#17a66b] text-white flex items-center justify-center shrink-0 shadow-2xs" }
const _hoisted_30 = { class: "min-w-0 flex-1 space-y-2" }
const _hoisted_31 = { class: "flex items-start gap-3 py-3" }
const _hoisted_32 = { class: "h-9 w-9 rounded-full bg-[#062d5f] text-white flex items-center justify-center shrink-0 shadow-2xs mt-0.5" }
const _hoisted_33 = { class: "space-y-2 flex flex-col items-center" }
const _hoisted_34 = { class: "flex items-center justify-between w-full" }
const _hoisted_35 = {
  key: 0,
  class: "text-[10px] font-bold text-[#16a34a] flex items-center gap-1"
}
const _hoisted_36 = { class: "w-full rounded-[2rem] overflow-hidden border border-[#cfe0f2] shadow-[0_16px_36px_rgba(4,36,91,0.12)] p-2.5 bg-gradient-to-br from-[#e6f0fa] to-white flex flex-col items-center justify-center" }
const _hoisted_37 = {
  key: 0,
  class: "text-[11px] text-[#be243d] font-bold mt-1 text-center"
}
const _hoisted_38 = { class: "rounded-[1.25rem] border border-[#d8e4f0] bg-white p-5 shadow-2xs space-y-4" }
const _hoisted_39 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 border-b border-[#f0f4fa] pb-3" }
const _hoisted_40 = { class: "flex flex-wrap items-center gap-2.5" }
const _hoisted_41 = { class: "flex items-center gap-1.5 rounded-full border border-[#bfdbfe] bg-[#eff6ff] px-3 py-1 shadow-2xs" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  label: "OpenAI"
}
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 1,
  label: "Local (Ollama)"
}
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "space-y-2.5" }
const _hoisted_48 = { class: "rounded-[0.95rem] border border-[#d8e4f0] bg-[#f8fbff] p-3 space-y-2" }
const _hoisted_49 = { class: "flex items-center justify-between gap-3" }
const _hoisted_50 = { class: "flex items-center gap-2.5 min-w-0" }
const _hoisted_51 = { class: "h-8 w-8 rounded-lg bg-[#eaf3fb] text-[#2855a6] flex items-center justify-center shrink-0" }
const _hoisted_52 = { class: "flex items-center gap-1.5 opacity-80 cursor-not-allowed" }
const _hoisted_53 = { class: "flex items-center justify-between gap-3" }
const _hoisted_54 = { class: "flex items-center gap-2.5 min-w-0" }
const _hoisted_55 = { class: "min-w-0" }
const _hoisted_56 = { class: "flex items-center gap-2" }
const _hoisted_57 = { class: "text-[0.88rem] font-black text-[#173b5f]" }
const _hoisted_58 = { class: "text-[0.82rem] text-[#64748b] truncate" }
const _hoisted_59 = { class: "flex items-center gap-2 shrink-0" }
const _hoisted_60 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_61 = ["onUpdate:modelValue", "onChange"]
const _hoisted_62 = {
  key: 0,
  class: "pt-1.5 border-t border-[#f0f4fa]"
}
const _hoisted_63 = ["onChange"]
const _hoisted_64 = {
  key: 0,
  class: "space-y-1.5"
}
const _hoisted_65 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_66 = { class: "font-bold max-w-[180px] truncate" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "font-bold max-w-[180px] truncate" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 2,
  class: "text-[11px] text-[#be243d] font-bold mt-1.5"
}
const _hoisted_74 = { class: "rounded-[0.95rem] border border-[#d8e4f0] bg-[#f8fbff] p-3 space-y-2" }
const _hoisted_75 = { class: "flex items-center justify-between gap-3" }
const _hoisted_76 = { class: "flex items-center gap-2.5 min-w-0" }
const _hoisted_77 = { class: "h-8 w-8 rounded-lg bg-[#eaf3fb] text-[#2855a6] flex items-center justify-center shrink-0" }
const _hoisted_78 = { class: "flex items-center gap-1.5 opacity-80 cursor-not-allowed" }
const _hoisted_79 = { class: "rounded-[1rem] border border-[#d8e4f0] bg-white p-3.5 shadow-2xs flex flex-wrap items-center justify-between gap-3" }
const _hoisted_80 = { class: "flex flex-wrap items-center gap-4 text-xs" }
const _hoisted_81 = { class: "flex items-center gap-1.5" }
const _hoisted_82 = { class: "flex items-center gap-1.5" }
const _hoisted_83 = { class: "flex items-center gap-1.5" }
const _hoisted_84 = { class: "font-bold text-[#1e293b]" }
const _hoisted_85 = {
  key: 0,
  class: "rounded-[1rem] border border-[#f5c2c7] bg-[#fff5f5] px-4 py-3 text-sm text-[#b42318] font-bold"
}
const _hoisted_86 = { class: "flex items-center gap-2.5" }

import { computed, reactive, ref, watch } from "vue";
import http from "@/services/http";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from "@/components/ui/dialog";
import type {
  GenerateMonthlyReportForm,
  ReportClientCard,
  ReportRecord,
} from "@/types/reports";
import {
  reportSectionConfig,
  type ReportSectionKey,
  type ReportSectionConfigItem,
  type ReportSectionFile,
  type ExtractedFileContent,
} from "./reportSectionConfig";
import InlineImageCanvasCropper from "./InlineImageCanvasCropper.vue";
import {
  X,
  Lock,
  Upload,
  Plus,
  FileText,
  BarChart3,
  Lightbulb,
  Share2,
  Bot,
  Podcast,
  Search,
  Megaphone,
  Users,
  Layers,
  Compass,
  CheckCircle2,
  AlertCircle,
  Image as ImageIcon,
  Trash2,
  Calendar,
  TrendingUp,
  Sparkles,
  Check,
} from "lucide-vue-next";

interface AiModel {
  name: string;
  provider: "openai" | "ollama";
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportBuilderModal',
  props: {
    open: { type: Boolean },
    loading: { type: Boolean },
    error: {},
    clients: {},
    selectedClient: {},
    report: {},
    selectedMonthNumber: {},
    mode: {}
  },
  emits: ["update:open", "generate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = computed({
  get: () => props.open,
  set: (value: boolean) => emit("update:open", value),
});

// ─── AI Model list ─────────────────────────────────────────────────────────────

const modelsLoading = ref(false);
const availableModels = ref<AiModel[]>([
  { name: "gpt-4o-mini", provider: "openai", label: "GPT-4o Mini (Default)" },
  { name: "gpt-4o",      provider: "openai", label: "GPT-4o (High Reasoning)" },
  { name: "gpt-4.1",      provider: "openai", label: "GPT-4.1 (Latest High Quality)" },
  { name: "gpt-4.1-mini", provider: "openai", label: "GPT-4.1 Mini (Fast & Capable)" },
  { name: "gpt-4.1-nano", provider: "openai", label: "GPT-4.1 Nano (Fastest & Cheapest)" },
  { name: "gpt-5",         provider: "openai", label: "GPT-5 (Flagship Reasoning)" },
  { name: "gpt-5-mini",    provider: "openai", label: "GPT-5 Mini (Fast Reasoning)" },
  { name: "gpt-5-nano",    provider: "openai", label: "GPT-5 Nano (Fastest)" },
]);

const openAiModels = computed(() =>
  availableModels.value.filter((m) => m.provider === "openai")
);
const ollamaModels = computed(() =>
  availableModels.value.filter((m) => m.provider === "ollama")
);

async function fetchAvailableModels() {
  modelsLoading.value = true;
  try {
    const { data } = await http.get("/api/ai/models");
    if (Array.isArray(data.models) && data.models.length > 0) {
      availableModels.value = data.models;
    }
  } catch {
    // Keep the hardcoded defaults on error
  } finally {
    modelsLoading.value = false;
  }
}

// ─── Form state ────────────────────────────────────────────────────────────────

const form = reactive({
  client_id: "",
  month_number: 1,
  report_month_label: "",
  title: "Monthly Progress Report",
  date_from: "",
  date_to: "",
  selected_sections: ["cover", "executive_snapshot", "recommendation"],
  status: "generated" as GenerateMonthlyReportForm["status"],
  publish: false,
  ai_model: "gpt-4o-mini",
});

const branding = reactive({
  logoFile: null as File | null,
  logoUrl: "",
  heroImageFile: null as File | null,
  heroImageUrl: "",
});

const logoInputRef = ref<HTMLInputElement | null>(null);
const bannerCropperRef = ref<InstanceType<typeof InlineImageCanvasCropper> | null>(null);

const executiveSnapshot = reactive({
  content: "",
});

const overallMonthlyRecommendation = reactive({
  content: "",
});

const sections = reactive<Record<ReportSectionKey, {
  enabled: boolean;
  existingFiles: ReportSectionFile[];
  newFiles: File[];
  removedFileIds: (number | string)[];
  insight: string;
  recommendation: string;
}>>({
  journey: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  socialMediaPerformance: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  aiChatbotManagement: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  aiPodcastProgress: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  blogManagement: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  seoManagement: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  adsManagement: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  generatedLeads: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
  promotionalMaterials: { enabled: false, existingFiles: [], newFiles: [], removedFileIds: [], insight: "", recommendation: "" },
});

const sectionExtractedContents = reactive<
  Record<ReportSectionKey, ExtractedFileContent[]>
>({
  journey: [],
  socialMediaPerformance: [],
  aiChatbotManagement: [],
  aiPodcastProgress: [],
  blogManagement: [],
  seoManagement: [],
  adsManagement: [],
  generatedLeads: [],
  promotionalMaterials: [],
});

const sectionFileInputRefs = ref<Record<string, HTMLInputElement | null>>({});
const errors = ref<Record<string, string>>({});
const preparedBy = ref("Proweaver");

// ─── Computeds ─────────────────────────────────────────────────────────────────

const preparedFor = computed(() => {
  return selectedClientRecord.value?.company_name || "Client";
});

const selectedClientRecord = computed(() => {
  return (
    props.clients.find((client) => client.client_id === form.client_id) ||
    null
  );
});

const isClientLocked = computed(() => !!props.selectedClient);

const monthOptions = computed(() =>
  Array.from({ length: 12 }, (_, index) => index + 1)
);

function isVisibleSection(sec: ReportSectionConfigItem): boolean {
  if (sec.key === "journey") {
    return Number(form.month_number) === 3;
  }
  return true;
}

const enabledSectionsCount = computed(() => {
  let count = 0;
  reportSectionConfig.forEach((sec) => {
    if (isVisibleSection(sec) && sections[sec.key]?.enabled) count++;
  });
  return count;
});

function getSectionIcon(key: ReportSectionKey) {
  switch (key) {
    case "journey": return Compass;
    case "socialMediaPerformance": return Share2;
    case "aiChatbotManagement": return Bot;
    case "aiPodcastProgress": return Podcast;
    case "blogManagement": return FileText;
    case "seoManagement": return Search;
    case "adsManagement": return Megaphone;
    case "generatedLeads": return Users;
    case "promotionalMaterials": return Layers;
    default: return FileText;
  }
}

// ─── Logo & Hero Handlers ──────────────────────────────────────────────────────

const hasReportLogo = computed(() => Boolean(branding.logoFile || branding.logoUrl));
const hasHeroImage = computed(() => Boolean(branding.heroImageFile || branding.heroImageUrl));

const logoPreviewUrl = computed(() => {
  if (branding.logoFile) {
    return URL.createObjectURL(branding.logoFile);
  }
  return branding.logoUrl || "";
});

function triggerLogoUpload() {
  logoInputRef.value?.click();
}

function handleLogoFileSelect(e: Event) {
  const target = e.target as HTMLInputElement;
  if (target.files?.[0]) {
    branding.logoFile = target.files[0];
    delete errors.value["logo"];
    target.value = "";
  }
}

function removeLogo() {
  branding.logoFile = null;
  branding.logoUrl = "";
}

function triggerHeroUpload() {
  bannerCropperRef.value?.triggerUpload();
}

function handleHeroChange(file: File | null) {
  branding.heroImageFile = file;
  if (file) {
    delete errors.value["hero_image"];
  }
}

// ─── File helpers ──────────────────────────────────────────────────────────────

function getAvailableSectionFiles(
  section: { existingFiles: ReportSectionFile[]; newFiles: File[]; removedFileIds: (number | string)[] }
): (ReportSectionFile | File)[] {
  const retainedExisting = (section.existingFiles ?? []).filter(
    (f) => !(section.removedFileIds ?? []).includes(f.id!)
  );
  return [...retainedExisting, ...(section.newFiles ?? [])];
}

function triggerSectionFileUpload(key: ReportSectionKey) {
  sectionFileInputRefs.value[key]?.click();
}

function handleSectionFileSelect(key: ReportSectionKey, e: Event) {
  const target = e.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    const files = Array.from(target.files);
    sections[key].newFiles = [...sections[key].newFiles, ...files];
    clearSectionErrors(key);
    target.value = "";
  }
}

function removeSectionNewFile(key: ReportSectionKey, index: number) {
  sections[key].newFiles.splice(index, 1);
}

function removeSectionExistingFile(key: ReportSectionKey, fileId: number | string) {
  if (!sections[key].removedFileIds.includes(fileId)) {
    sections[key].removedFileIds.push(fileId);
  }
}

// ─── Per-section validity ─────────────────────────────────────────────────────

function isSectionValid(sectionKey: ReportSectionKey): boolean {
  const config = reportSectionConfig.find((c) => c.key === sectionKey);
  const section = sections[sectionKey];

  if (!config || !section) return false;
  if (!isVisibleSection(config)) return true;
  if (!section.enabled) return true;

  if (config.requiresFiles && getAvailableSectionFiles(section).length === 0) {
    return false;
  }
  return true;
}

const missingSectionFiles = computed(() => {
  const missing: string[] = [];
  reportSectionConfig.forEach((sec) => {
    if (isVisibleSection(sec) && sections[sec.key]?.enabled && sec.requiresFiles) {
      if (getAvailableSectionFiles(sections[sec.key]).length === 0) {
        missing.push(sec.label);
      }
    }
  });
  return missing;
});

const enabledSectionsAreValid = computed(() => {
  return reportSectionConfig.every((config) => isSectionValid(config.key));
});

const isReportFormValid = computed(() => {
  const requiredFieldsValid =
    Boolean(form.client_id) &&
    Boolean(form.title?.trim()) &&
    Boolean(form.report_month_label?.trim());

  return (
    requiredFieldsValid &&
    hasReportLogo.value &&
    hasHeroImage.value &&
    enabledSectionsAreValid.value
  );
});

// ─── Error helpers ─────────────────────────────────────────────────────

function clearSectionErrors(key: ReportSectionKey) {
  delete errors.value[`sections.${key}.files`];
  delete errors.value[`sections.${key}.insight`];
  delete errors.value[`sections.${key}.recommendation`];
}

function onSectionToggle(key: ReportSectionKey) {
  const state = sections[key];
  if (!state.enabled) {
    state.newFiles.forEach((file) => {
      const objUrl = (file as any).previewUrl;
      if (objUrl) URL.revokeObjectURL(objUrl);
    });
    state.newFiles = [];
    state.removedFileIds = [];
    sectionExtractedContents[key] = [];
    clearSectionErrors(key);
  }
}

function selectAllSections() {
  reportSectionConfig.forEach((sec) => {
    if (isVisibleSection(sec)) {
      sections[sec.key].enabled = true;
    }
  });
}

function deselectAllSections() {
  reportSectionConfig.forEach((sec) => {
    if (isVisibleSection(sec)) {
      sections[sec.key].enabled = false;
      onSectionToggle(sec.key);
    }
  });
}

// ─── Defaults & Form Reset ─────────────────────────────────────────────────────

function setDefaults() {
  form.client_id =
    props.selectedClient?.client_id ||
    props.report?.client_id ||
    props.clients[0]?.client_id ||
    "";

  form.month_number =
    props.selectedMonthNumber ||
    props.report?.month_number ||
    1;

  form.report_month_label =
    props.report?.report_month_label ||
    `Month ${form.month_number} Report`;

  form.title = props.report?.title || "Monthly Progress Report";
  form.date_from = props.report?.date_from || "";
  form.date_to = props.report?.date_to || "";
  form.publish = false;
  form.status = "generated";
  form.ai_model = "gpt-4o-mini";

  preparedBy.value =
    (props.report?.report_data as Record<string, any>)?.prepared_by ||
    "Proweaver";

  branding.logoFile = null;
  branding.logoUrl = "";
  branding.heroImageFile = null;
  branding.heroImageUrl = "";

  errors.value = {};

  reportSectionConfig.forEach((sec) => {
    sections[sec.key] = {
      enabled: false,
      existingFiles: [],
      newFiles: [],
      removedFileIds: [],
      insight: "",
      recommendation: "",
    };
  });

  if (props.report) {
    const reportData = (props.report.report_data || {}) as Record<string, any>;
    form.ai_model = reportData.ai_model || "gpt-4o-mini";
    executiveSnapshot.content = reportData.executive_snapshot_note || reportData.executive_note || "";
    overallMonthlyRecommendation.content = reportData.overall_recommendation_summary || reportData.recommendation_summary || "";

    const logoAsset = props.report.assets?.find(
      (a) => a.section_key === "report_logo" || a.section_key === "logo"
    );
    branding.logoUrl = logoAsset ? logoAsset.url : "";

    const heroAsset = props.report.assets?.find(
      (a) => a.section_key === "hero_banner" || a.section_key === "hero_image"
    );
    branding.heroImageUrl = heroAsset ? heroAsset.url : "";

    reportSectionConfig.forEach((sec) => {
      const isEnabled = props.report?.selected_sections?.includes(sec.key);
      const secData = reportData.sections?.[sec.key] || {};

      const dbKeys = [sec.dbKey, sec.key];
      const existingFiles = (props.report?.assets || [])
        .filter((asset) => dbKeys.includes(asset.section_key || ""))
        .map((asset) => ({
          id: asset.id,
          name: asset.original_name,
          size: asset.size,
          mimeType: asset.mime_type,
          url: asset.url,
          source: "server" as const,
        }));

      sections[sec.key] = {
        enabled: !!isEnabled,
        existingFiles,
        newFiles: [],
        removedFileIds: [],
        insight: secData.insight || "",
        recommendation: secData.recommendation || "",
      };
    });
  } else {
    form.selected_sections = ["cover", "executive_snapshot", "recommendation"];
  }
}

function validateReportForm(): boolean {
  errors.value = {};
  let isValid = true;

  if (!form.client_id) {
    errors.value["client_id"] = "Client is required";
    isValid = false;
  }
  if (!form.title?.trim()) {
    errors.value["title"] = "Report Title is required";
    isValid = false;
  }
  if (!form.report_month_label?.trim()) {
    errors.value["report_month_label"] = "Report Month Label is required";
    isValid = false;
  }

  if (!branding.logoFile && !branding.logoUrl) {
    errors.value["logo"] = "Report Logo is required.";
    isValid = false;
  }
  if (!branding.heroImageFile && !branding.heroImageUrl) {
    errors.value["hero_image"] = "Hero Banner Image is required.";
    isValid = false;
  }

  reportSectionConfig.forEach((sec) => {
    const state = sections[sec.key];
    if (!state.enabled) return;

    if (sec.requiresFiles && getAvailableSectionFiles(state).length === 0) {
      errors.value[`sections.${sec.key}.files`] =
        "At least one supporting file is required.";
      isValid = false;
    }
  });

  return isValid;
}

function serializeReportPayload() {
  const selected: string[] = ["cover", "executive_snapshot", "recommendation"];
  const payloadSections: Record<string, { enabled: boolean; insight?: string; recommendation?: string }> = {};

  reportSectionConfig.forEach((sec) => {
    const s = sections[sec.key];
    if (isVisibleSection(sec) && s.enabled) {
      selected.push(sec.key);
      payloadSections[sec.key] = {
        enabled: true,
        insight: s.insight,
        recommendation: s.recommendation?.trim() ? s.recommendation : undefined,
      };
    } else {
      payloadSections[sec.key] = { enabled: false };
    }
  });

  const reportData = {
    prepared_by: preparedBy.value,
    generated_by: "Current User",
    template: "Proweaver Monthly Progress Report",
    executive_snapshot_note: executiveSnapshot.content,
    overall_recommendation_summary: overallMonthlyRecommendation.content,
    sections: payloadSections,
    ai_model: form.ai_model,
  };

  let allRemovedFileIds: (number | string)[] = [];
  reportSectionConfig.forEach((sec) => {
    if (sections[sec.key].enabled) {
      allRemovedFileIds = [...allRemovedFileIds, ...sections[sec.key].removedFileIds];
    }
  });

  const payload: GenerateMonthlyReportForm = {
    client_id: form.client_id,
    month_number: form.month_number,
    report_month_label: form.report_month_label,
    title: form.title,
    date_from: form.date_from,
    date_to: form.date_to,
    selected_sections: selected,
    report_data_json: JSON.stringify(reportData),
    publish: form.publish,
    status: form.status,
    sections: payloadSections,
    removedFileIds: allRemovedFileIds,
  };

  const uploadFiles: Record<string, File[]> = {};

  if (branding.logoFile) {
    uploadFiles["logo"] = [branding.logoFile];
  }
  if (branding.heroImageFile) {
    uploadFiles["hero_image"] = [branding.heroImageFile];
  }

  reportSectionConfig.forEach((sec) => {
    const s = sections[sec.key];
    if (s.enabled && s.newFiles.length > 0) {
      uploadFiles[`sections[${sec.key}][files]`] = s.newFiles;
    }
  });

  const extractedPayload: Record<string, string> = {};
  reportSectionConfig.forEach((sec) => {
    const contents = sectionExtractedContents[sec.key];
    if (sections[sec.key].enabled && contents && contents.length > 0) {
      extractedPayload[`sections[${sec.key}][extracted_contents]`] = JSON.stringify(contents);
    }
  });

  return { payload, files: uploadFiles, extractedPayload };
}

function submit(submitAction: "draft" | "html" | "pdf" | "generate") {
  if (!validateReportForm()) {
    const firstError = document.querySelector("[class*='text-\\[#be243d\\]']");
    firstError?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }

  form.publish = submitAction === "generate" || submitAction === "pdf";
  form.status = submitAction === "draft" ? "draft" : "generated";

  const { payload, files, extractedPayload } = serializeReportPayload();

  emit("generate", {
    payload,
    files,
    action: submitAction,
    reportId: props.report?.id || null,
    extractedPayload,
  });
}

function emitClose() {
  emit("update:open", false);
}

watch(
  () => [props.open, props.selectedClient, props.selectedMonthNumber, props.report],
  ([open]) => {
    if (open) {
      setDefaults();
      fetchAvailableModels();
    }
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "report-builder-dialog-content h-[92vh] max-h-[94vh] w-[95vw] max-w-[1140px] flex flex-col overflow-hidden rounded-[1.5rem] border border-[#d8e4f0] bg-[#f8fbff] p-0 shadow-[0_24px_70px_rgba(15,23,42,0.22)] gap-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.mode === "edit" ? "Edit Monthly Report" : "Generate Monthly Report"), 1),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-[#64748b] mt-0.5" }, " Configure cover branding, metadata, and active sections with an interactive cover page layout. ", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "flex h-8 w-8 items-center justify-center rounded-xl text-[#64748b] hover:bg-[#f1f5f9] hover:text-[#0f172a] transition cursor-pointer shrink-0",
              onClick: emitClose
            }, [
              _createVNode(_unref(X), { class: "h-4 w-4" })
            ])
          ]),
          _createElementVNode("form", {
            class: "flex-1 min-h-0 flex flex-col overflow-hidden",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (submit('generate')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(FileText), { class: "h-3.5 w-3.5 text-[#2855a6]" }),
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Interactive Cover Preview", -1))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-[9.5px] font-extrabold uppercase tracking-wider text-[#748197]" }, "Doc Title:", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                      type: "text",
                      class: "bg-transparent text-[11px] font-bold text-[#173b5f] focus:outline-none w-44",
                      placeholder: "Monthly Progress Report"
                    }, null, 512), [
                      [_vModelText, form.title]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        ref_key: "logoInputRef",
                        ref: logoInputRef,
                        type: "file",
                        class: "hidden",
                        accept: ".png,.jpg,.jpeg,.webp,.svg",
                        onChange: handleLogoFileSelect
                      }, null, 544),
                      (hasReportLogo.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "relative w-[88px] h-[88px] rounded-2xl flex items-center justify-center group cursor-pointer border border-transparent hover:border-[#cfe0f2] hover:bg-white/60 p-1.5 transition-all",
                            title: "Click canvas to change client logo",
                            onClick: triggerLogoUpload
                          }, [
                            _createElementVNode("img", {
                              src: logoPreviewUrl.value,
                              alt: "Client Logo",
                              class: "max-h-full max-w-full object-contain select-none pointer-events-none"
                            }, null, 8, _hoisted_10),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "h-6 w-6 rounded-full bg-white text-[#173b5f] shadow-md hover:bg-[#f1f5f9] flex items-center justify-center cursor-pointer border border-[#d8e4f0]",
                                title: "Change Logo",
                                onClick: _withModifiers(triggerLogoUpload, ["stop"])
                              }, [
                                _createVNode(_unref(Upload), { class: "h-3 w-3 text-[#2855a6]" })
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "h-6 w-6 rounded-full bg-[#be243d] hover:bg-[#9c182d] text-white shadow-md flex items-center justify-center cursor-pointer",
                                title: "Remove Logo",
                                onClick: _withModifiers(removeLogo, ["stop"])
                              }, [
                                _createVNode(_unref(Trash2), { class: "h-3 w-3" })
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "w-[88px] h-[88px] rounded-2xl border-2 border-dashed border-[#c1cfe1] hover:border-[#2855a6] bg-white/40 hover:bg-white/80 p-2 flex flex-col items-center justify-center gap-1 transition cursor-pointer group shadow-2xs",
                            title: "Click to select client logo",
                            onClick: triggerLogoUpload
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_unref(Upload), { class: "h-4 w-4" })
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-center select-none pointer-events-none" }, [
                              _createElementVNode("div", { class: "text-[10px] font-black text-[#173b5f]" }, "Logo")
                            ], -1))
                          ])),
                      (errors.value['logo'])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errors.value['logo']), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (isClientLocked.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("h1", _hoisted_16, _toDisplayString(preparedFor.value), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Client Account ", -1)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.client_id) = $event)),
                              class: "field-input font-black text-[#062d5f]"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clients, (client) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: client.id,
                                  value: client.client_id
                                }, _toDisplayString(client.company_name) + " (" + _toDisplayString(client.client_id) + ") ", 9, _hoisted_18))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, form.client_id]
                            ]),
                            (errors.value['client_id'])
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(errors.value['client_id']), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("div", {
                      class: "h-[4px] w-52 rounded-full my-2.5",
                      style: {"background":"linear-gradient(90deg, #0b3f75 0 24%, #e5192d 24% 49%, #f5a300 49% 74%, #17a66b 74% 100%)"}
                    }, null, -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-[13px] font-medium leading-snug text-[#5f6672]" }, " Digital Marketing Partner Monthly Performance Update ", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_unref(Calendar), { class: "h-4 w-4" })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-[11px] font-extrabold text-[#0b3f75] uppercase tracking-[0.07em]" }, " Report Month ", -1)),
                          _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.month_number) = $event)),
                              class: "field-input w-auto min-w-[110px] font-bold cursor-pointer"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthOptions.value, (month) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: month,
                                  value: month
                                }, " Month " + _toDisplayString(month), 9, _hoisted_25))
                              }), 128))
                            ], 512), [
                              [
                                _vModelSelect,
                                form.month_number,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.report_month_label) = $event)),
                              class: "field-input flex-1 min-w-[150px]",
                              type: "text",
                              placeholder: "e.g. May – June 2026"
                            }, null, 512), [
                              [_vModelText, form.report_month_label]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-[11px] font-extrabold text-[#748197] uppercase tracking-[0.07em] shrink-0" }, "Range:", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.date_from) = $event)),
                              type: "date",
                              class: "field-input w-auto"
                            }, null, 512), [
                              [_vModelText, form.date_from]
                            ]),
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-[13px] text-[#94a3b8] font-medium shrink-0" }, "to", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.date_to) = $event)),
                              type: "date",
                              min: form.date_from || undefined,
                              class: "field-input w-auto"
                            }, null, 8, _hoisted_27), [
                              [_vModelText, form.date_to]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_unref(TrendingUp), { class: "h-4 w-4" })
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-[11px] font-extrabold text-[#0b3f75] uppercase tracking-[0.07em]" }, " Prepared By ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((preparedBy).value = $event)),
                            class: "field-input",
                            type: "text",
                            placeholder: "Proweaver"
                          }, null, 512), [
                            [_vModelText, preparedBy.value]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_unref(Check), { class: "h-4 w-4 stroke-[3]" })
                        ]),
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-sm text-[#475569] font-medium leading-relaxed pt-1.5" }, " Supporting stronger visibility, inquiry pathways, and lead tracking across digital channels. ", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-[0.68rem] font-extrabold uppercase tracking-[0.08em] text-[#748197]" }, " Cover Hero Banner (1:1 Frame) ", -1)),
                      (hasHeroImage.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                            _createVNode(_unref(CheckCircle2), { class: "h-3 w-3" }),
                            _cache[24] || (_cache[24] = _createTextVNode(" Framed ", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(InlineImageCanvasCropper, {
                        ref_key: "bannerCropperRef",
                        ref: bannerCropperRef,
                        "model-value": branding.heroImageFile,
                        "existing-url": branding.heroImageUrl,
                        "aspect-ratio": 1,
                        "is-banner": true,
                        label: "Click to Select Hero Banner",
                        hint: "PNG, JPG, WEBP • Drag to pan & Ctrl+Scroll to zoom",
                        accept: ".png,.jpg,.jpeg,.webp",
                        "max-size-m-b": 10,
                        "target-width": 1200,
                        "target-height": 1200,
                        "file-name": "hero-banner.png",
                        "onUpdate:modelValue": handleHeroChange
                      }, null, 8, ["model-value", "existing-url"])
                    ]),
                    (errors.value['hero_image'])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(errors.value['hero_image']), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-[0.94rem] font-black text-[#173b5f]" }, " Section Modules "),
                    _createElementVNode("p", { class: "text-[0.88rem] text-[#64748b] mt-0.5" }, " Select which modules to generate and attach corresponding raw data files. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_unref(Sparkles), { class: "h-3.5 w-3.5 text-[#2563eb]" }),
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-[11px] font-extrabold text-[#1e3a5f]" }, "AI Model:", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.ai_model) = $event)),
                        class: "bg-transparent text-xs font-bold text-[#2563eb] focus:outline-none cursor-pointer",
                        disabled: modelsLoading.value
                      }, [
                        (openAiModels.value.length)
                          ? (_openBlock(), _createElementBlock("optgroup", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openAiModels.value, (m) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: m.name,
                                  value: m.name
                                }, _toDisplayString(m.label), 9, _hoisted_44))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (ollamaModels.value.length)
                          ? (_openBlock(), _createElementBlock("optgroup", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ollamaModels.value, (m) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: m.name,
                                  value: m.name
                                }, _toDisplayString(m.label), 9, _hoisted_46))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_42), [
                        [_vModelSelect, form.ai_model]
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-xs font-bold text-[#2855a6] hover:text-[#173b5f] hover:underline cursor-pointer",
                      onClick: selectAllSections
                    }, " Select All "),
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-[#cbd5e1]" }, "•", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-xs font-bold text-[#64748b] hover:text-[#dc2626] cursor-pointer",
                      onClick: deselectAllSections
                    }, " Clear All ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_unref(BarChart3), { class: "h-4 w-4" })
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("div", { class: "flex items-center gap-2" }, [
                            _createElementVNode("span", { class: "text-[0.88rem] font-black text-[#173b5f]" }, "Executive Snapshot"),
                            _createElementVNode("span", { class: "pill pill-blue" }, "Required")
                          ]),
                          _createElementVNode("p", { class: "text-[0.82rem] text-[#64748b] truncate" }, " Summarizes metric cards and overall progress. ")
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[30] || (_cache[30] = _createElementVNode("input", {
                          type: "checkbox",
                          checked: "",
                          disabled: "",
                          class: "h-4 w-4 rounded border-[#c1cfe1] text-[#2855a6]"
                        }, null, -1)),
                        _createVNode(_unref(Lock), { class: "h-3 w-3 text-[#94a3b8]" })
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportSectionConfig), (section) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: section.key
                    }, [
                      (isVisibleSection(section))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["rounded-[0.95rem] border transition-all p-3 space-y-2", sections[section.key].enabled ? 'border-[#2855a6] bg-[#fdfeff] shadow-2xs' : 'border-[#e2eaf4] bg-white opacity-85 hover:opacity-100'])
                          }, [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["h-8 w-8 rounded-lg flex items-center justify-center shrink-0 transition-colors", sections[section.key].enabled ? 'bg-[#eaf3fb] text-[#2855a6]' : 'bg-slate-100 text-slate-500'])
                                }, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(getSectionIcon(section.key)), { class: "h-4 w-4" }))
                                ], 2),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(section.label), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["pill", section.requiresFiles ? 'pill-blue' : 'pill-yellow'])
                                    }, " Optional ", 2)
                                  ]),
                                  _createElementVNode("p", _hoisted_58, _toDisplayString(section.helper), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("label", _hoisted_60, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((sections[section.key].enabled) = $event),
                                    type: "checkbox",
                                    class: "sr-only peer",
                                    onChange: ($event: any) => (onSectionToggle(section.key))
                                  }, null, 40, _hoisted_61), [
                                    [_vModelCheckbox, sections[section.key].enabled]
                                  ]),
                                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#2855a6]" }, null, -1))
                                ])
                              ])
                            ]),
                            (sections[section.key].enabled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("input", {
                                    ref_for: true,
                                    ref: (el) => { if (el) sectionFileInputRefs.value[section.key] = el as HTMLInputElement },
                                    type: "file",
                                    class: "hidden",
                                    multiple: "",
                                    onChange: ($event: any) => (handleSectionFileSelect(section.key, $event))
                                  }, null, 40, _hoisted_63),
                                  (getAvailableSectionFiles(sections[section.key]).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections[section.key].existingFiles.filter(f => !sections[section.key].removedFileIds.includes(f.id!)), (file) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: file.id,
                                              class: "inline-flex items-center gap-2 rounded-lg border border-[#c5d8ea] bg-[#f0f6fc] px-2.5 py-1 text-xs text-[#1e3a5f]"
                                            }, [
                                              _createVNode(_unref(FileText), { class: "h-3.5 w-3.5 text-[#2855a6]" }),
                                              _createElementVNode("span", _hoisted_66, _toDisplayString(file.name), 1),
                                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "pill pill-green text-[9px] py-0 px-1.5" }, "Uploaded", -1)),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "text-[#dc2626] hover:text-[#b91c1c] text-[11px] font-bold ml-1 cursor-pointer",
                                                title: "Remove file",
                                                onClick: ($event: any) => (removeSectionExistingFile(section.key, file.id!))
                                              }, " Remove ", 8, _hoisted_67)
                                            ]))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections[section.key].newFiles, (file, idx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: idx,
                                              class: "inline-flex items-center gap-2 rounded-lg border border-[#bbf7d0] bg-[#f0fdf4] px-2.5 py-1 text-xs text-[#166534]"
                                            }, [
                                              _createVNode(_unref(FileText), { class: "h-3.5 w-3.5 text-[#16a34a]" }),
                                              _createElementVNode("span", _hoisted_68, _toDisplayString(file.name), 1),
                                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "pill pill-green text-[9px] py-0 px-1.5" }, "Ready", -1)),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "text-[#dc2626] hover:text-[#b91c1c] text-[11px] font-bold ml-1 cursor-pointer",
                                                title: "Remove file",
                                                onClick: ($event: any) => (removeSectionNewFile(section.key, idx))
                                              }, " Remove ", 8, _hoisted_69)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "inline-flex items-center gap-1 text-[11px] font-bold text-[#2855a6] hover:underline cursor-pointer ml-1",
                                            onClick: ($event: any) => (triggerSectionFileUpload(section.key))
                                          }, [
                                            _createVNode(_unref(Plus), { class: "h-3 w-3" }),
                                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "Add file", -1))
                                          ], 8, _hoisted_70)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "inline-flex items-center gap-1.5 rounded-lg border border-[#d7e2ef] bg-[#f6f9ff] hover:bg-[#eaf3fb] hover:border-[#bfdbfe] px-3 py-1.5 text-xs font-bold text-[#2855a6] transition cursor-pointer shadow-2xs",
                                          onClick: ($event: any) => (triggerSectionFileUpload(section.key))
                                        }, [
                                          _createVNode(_unref(Upload), { class: "h-3.5 w-3.5" }),
                                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "Upload file", -1))
                                        ], 8, _hoisted_72),
                                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-[11px] text-[#748197]" }, " Upload the source file for this section. ", -1))
                                      ])),
                                  (errors.value[`sections.${section.key}.files`])
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(errors.value[`sections.${section.key}.files`]), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_unref(Lightbulb), { class: "h-4 w-4" })
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("div", { class: "flex items-center gap-2" }, [
                            _createElementVNode("span", { class: "text-[0.88rem] font-black text-[#173b5f]" }, "Monthly Recommendations"),
                            _createElementVNode("span", { class: "pill pill-blue" }, "Required")
                          ]),
                          _createElementVNode("p", { class: "text-[0.82rem] text-[#64748b] truncate" }, " Includes strategic roadmap and general recommendations. ")
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _cache[38] || (_cache[38] = _createElementVNode("input", {
                          type: "checkbox",
                          checked: "",
                          disabled: "",
                          class: "h-4 w-4 rounded border-[#c1cfe1] text-[#2855a6]"
                        }, null, -1)),
                        _createVNode(_unref(Lock), { class: "h-3 w-3 text-[#94a3b8]" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    (hasReportLogo.value)
                      ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                          key: 0,
                          class: "h-4 w-4 text-[#16a34a] shrink-0"
                        }))
                      : (_openBlock(), _createBlock(_unref(AlertCircle), {
                          key: 1,
                          class: "h-4 w-4 text-[#ea580c] shrink-0"
                        })),
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold", hasReportLogo.value ? 'text-[#1e293b]' : 'text-[#ea580c]'])
                    }, _toDisplayString(hasReportLogo.value ? 'Logo ready' : 'Logo missing (required)'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    (hasHeroImage.value)
                      ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                          key: 0,
                          class: "h-4 w-4 text-[#16a34a] shrink-0"
                        }))
                      : (_openBlock(), _createBlock(_unref(AlertCircle), {
                          key: 1,
                          class: "h-4 w-4 text-[#ea580c] shrink-0"
                        })),
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold", hasHeroImage.value ? 'text-[#1e293b]' : 'text-[#ea580c]'])
                    }, _toDisplayString(hasHeroImage.value ? 'Hero banner framed' : 'Hero banner missing (required)'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    (enabledSectionsCount.value > 0 && missingSectionFiles.value.length === 0)
                      ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                          key: 0,
                          class: "h-4 w-4 text-[#16a34a] shrink-0"
                        }))
                      : (_openBlock(), _createBlock(_unref(AlertCircle), {
                          key: 1,
                          class: "h-4 w-4 text-[#ea580c] shrink-0"
                        })),
                    _createElementVNode("span", _hoisted_84, _toDisplayString(enabledSectionsCount.value) + " section" + _toDisplayString(enabledSectionsCount.value === 1 ? '' : 's') + " enabled ", 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-[11px] font-black px-3 py-1 rounded-full", isReportFormValid.value ? 'bg-[#ecfdf5] text-[#15803d]' : 'bg-[#fff7ed] text-[#c2410c]'])
                }, _toDisplayString(isReportFormValid.value ? '✓ Ready to Generate' : 'Action Required'), 3)
              ]),
              (__props.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(__props.error), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(DialogFooter), { class: "flex-shrink-0 border-t border-[#e3eaf4] px-7 py-3.5 bg-white z-10 flex items-center justify-between" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  type: "button",
                  variant: "outline",
                  class: "rounded-[0.95rem] border-[#d7e2ef] bg-white px-5 py-2 font-bold text-[#2855a6] hover:bg-[#f6f9ff] cursor-pointer",
                  onClick: emitClose
                }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(_unref(Button), {
                    type: "button",
                    class: "rounded-[0.95rem] bg-[#6b7a90] hover:bg-[#59667a] px-5 py-2 font-bold text-white cursor-pointer",
                    disabled: __props.loading,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (submit('draft')))
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode(" Save Draft ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(Button), {
                    type: "button",
                    class: _normalizeClass(["rounded-[0.95rem] px-6 py-2 font-black text-white transition-all shadow-sm cursor-pointer", isReportFormValid.value && !__props.loading ? 'bg-[#173b5f] hover:bg-[#0f2742]' : 'bg-[#94a3b8] cursor-not-allowed']),
                    disabled: !isReportFormValid.value || __props.loading,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (submit('generate')))
                  }, {
                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createTextVNode(" Generate Report ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class", "disabled"])
                ])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})